import apiClient from './api/apiClient';

export async function createExample(data) {
  const response = await apiClient.post('/admin/templates/examples', data);
  return response;
}

export async function updateExample(exampleId, updatedData) {
  const response = await apiClient.patch(`/admin/templates/examples/${exampleId}`, updatedData);
  return response;
}

export async function deleteExample(exampleId) {
  const response = await apiClient.delete(`/admin/templates/examples/${exampleId}`);
  return response;
}
